<template>
  <stepper-content-card
    @skipStep="$emit('skipStep')"
    @changeStep="handleStepChange"
    :dataLoading="dataLoading"
    :step="4"
    imgUrl="https://images.unsplash.com/photo-1522096823084-2d1aa8411c13?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1470&q=80"
  >
    <div slot="heading">Contact Info</div>
    <div slot="subheading">Let us know you better</div>
    <div slot="body">
      <v-row no-gutters>
        <!-- <v-col cols="12">
          <v-text-field
            class="mt-4"
            outlined
            dense
            v-model="name"
            label="Full Name"
            hide-details
          />
        </v-col> -->
        <!-- <v-col cols="12">
          <v-text-field
            class="mt-4"
            outlined
            dense
            v-model="workEmail"
            label="Email"
            hide-details
          />
        </v-col> -->
        <v-col cols="12">
          <v-text-field
            class="mt-4"
            outlined
            dense
            v-model="mobile"
            type="tel"
            label="Phone"
            hide-details
            persistent-hint
            prepend-inner-icon="mdi-phone"
          />
        </v-col>
        <v-col cols="12">
          <v-text-field
            class="mt-4"
            outlined
            dense
            v-model="whatsapp"
            type="tel"
            label="Whatsapp Number"
            prepend-inner-icon="mdi-whatsapp"
            persistent-hint
            hide-details
          />
        </v-col>
        <v-col cols="12">
          <v-text-field
            class="mt-4"
            outlined
            dense
            prepend-inner-icon="mdi-linkedin"
            label="LinkedIn (Optional)"
            hide-details
          />
        </v-col>         
        <v-col cols="12">
          <v-text-field
            class="mt-4"
            outlined
            dense
            prepend-inner-icon="mdi-github"
            label="Github Link (Optional)"
            hide-details
          />
        </v-col>         
        <!-- <v-col cols="12">
          <v-text-field
            class="mt-4"
            outlined
            dense
            v-model="instagram"
            prepend-inner-icon="mdi-linkedin"
            label="Instagram Username (Optional)"
            hide-details
          />
        </v-col>          -->
      </v-row>
    </div>
  </stepper-content-card>
</template>

<script>
import StepperContentCard from "./StepperContentCard";
import { mapGetters } from 'vuex'

export default {
  props: ["currentPerson", "dataLoading"],
  data() {
    return {
      mobile: "",
      instagram: "",
      whatsapp: ""
    };
  },
  mounted() {
    this.mobile = this.currentPerson.mobile
    this.instagram = this.currentPerson.instagram
    this.whatsapp = this.currentPerson.whatsapp
  }, 
  computed: {
    ...mapGetters(['currentUser'])
  },
  methods: {
    handleStepChange() {

      if(this.mobile.trim().length !== 10) {
        this.$setSnackbar("10 digit phone is required")
        return
      }

      this.$emit("changeStep", {
        mobile: this.mobile,
        whatsapp: this.whatsapp,
        instagram: this.instagram,
      });
    },
  },
  components: {
    StepperContentCard,
  },
};
</script>